// Feature bitmap for THIS storefront's Key API tenant (ACCTV — the TV product family).
// Bits are TENANT-SCOPED: the same value means a different app in the ACCDRIVE tenant, so
// we deliberately do NOT reuse the generic FeatureCheck enum here.
//
//   ACCTV tenant bits:  1 = ACC TV, 2 = ACC TV Pro, 4 = IncidentManager,
//                       512 = LMU TV, 1024 = LMU TV Pro
//
// "Apps" get an icon (a product a key unlocks); "sub-features" (Pro, IncidentManager) are
// shown as small badges, not separate apps.
import accTvLogo from "../media/accTV.png";
import lmuTvLogo from "../media/lmuTV.png";

export interface TenantApp {
  bit: number;
  name: string;
  logo: string;
}

export const TENANT_APPS: TenantApp[] = [
  { bit: 1, name: "ACC TV", logo: accTvLogo },
  { bit: 512, name: "LMU TV", logo: lmuTvLogo },
];

export const TENANT_SUBFEATURES: { bit: number; name: string }[] = [
  { bit: 2, name: "ACC TV Pro" },
  { bit: 4, name: "IncidentManager" },
  { bit: 1024, name: "LMU TV Pro" },
];

const LMUTV_BIT = 512;

export const appsFor = (features: number): TenantApp[] =>
  TENANT_APPS.filter((a) => (features & a.bit) === a.bit);

export const subFeaturesFor = (features: number): string[] =>
  TENANT_SUBFEATURES.filter((s) => (features & s.bit) === s.bit).map((s) => s.name);

// Whether a key is an LMU TV key — only those can have their seat COUNT changed here,
// since this storefront only sells LMU TV plans (ACC TV pricing lives elsewhere).
export const isLmuTvKey = (features: number): boolean => (features & LMUTV_BIT) === LMUTV_BIT;
